const tooltip = [
    {
        selector: '[data-tooltip]',
        path: { filename: 'tooltip' },
    },
];

export { tooltip };
